/**
 * Status codes for content synchronization events
 */
export var SyncStatusCode;
(function (SyncStatusCode) {
    /** Unauthorized access - authentication failed or token expired */
    SyncStatusCode[SyncStatusCode["Unauthorized"] = 401] = "Unauthorized";
    /** WebSocket successfully connected */
    SyncStatusCode[SyncStatusCode["WebSocketConnected"] = 1000] = "WebSocketConnected";
    /** WebSocket disconnected */
    SyncStatusCode[SyncStatusCode["WebSocketDisconnected"] = 1001] = "WebSocketDisconnected";
    /** Connection established - server is reachable and ready to receive requests again */
    SyncStatusCode[SyncStatusCode["ConnectionEstablished"] = 1100] = "ConnectionEstablished";
    /** Connection refused - server is unreachable */
    SyncStatusCode[SyncStatusCode["ConnectionRefused"] = 1101] = "ConnectionRefused";
})(SyncStatusCode || (SyncStatusCode = {}));
//# sourceMappingURL=SyncStatusCode.js.map